<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <b-table
          hover
          ref="selectableTable"
          :items="allTasks"
          :fields="tableFields"
          responsive="sm"
        >
          <template #cell(state)="task">
            {{ getBeautifiedTaskStatus(task.item.state) }}
          </template>
          <template #cell(date)="task">
            {{ formatDate(task.item.startDate) }} - {{ formatDate(task.item.endDate) }}
          </template>
          <template #cell(actions)="task">
            <ul class="list-inline font-size-20 contact-links mb-0">
              <li class="list-inline-item px-2">
                <a
                v-b-tooltip.hover
                :title= "$t('tasks.actions.show-details')"
                @click="showTaskDetails(task.item.id)"
                class="task--function task--function__show-task"
                >
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </a>
              </li>
              <li class="list-inline-item px-2">
                <a
                  v-b-tooltip.hover
                  :title= "$t('tasks.actions.cancel')"
                  @click="cancelTask(task.item)"
                  class="task--function task--function__delete-task"
                  >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </template>
        </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import i18n from '@/i18n';
import router from '../../..';
import { taskService } from "@/helpers/services/tasks/taskService";
import { dateHelper } from "@/helpers/utils/dateHelper";


export default {
  name: "OpenTasks",
  props: {
    editable: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: i18n.t('tasks.overview.open-tasks.title'), active: true},
      ],
      tableFields: this.getTableFields(),
      allTasks: [],
    }
  },
  methods: {
    formatDate(date) {
      return dateHelper.toGermanDateTime(date);
    },
    showTaskDetails(taskId) {
      router.push({ path: `/task/${taskId}/status` });
    },
    getTableFields() {
      const fields = [
        { key: "title", label: i18n.t("tasks.title") },
        { key: "state", label: i18n.t("tasks.state") },
        { key: "date", label: i18n.t("tasks.date") },
        { key: "departmentName", label: i18n.t("departments.name-singular") },
      ];

      if (this.editable) {
        fields.push({ key: "actions", label: i18n.t("actions") });
      }

      return fields;
    },
    getBeautifiedTaskStatus(state) {
      return taskService.getBeautifiedTaskState(state);
    },
    fetchOpenTasks() {
      taskService.fetchOpenTasks()
      .then(tasks => this.allTasks = tasks);
    },
    cancelTask(task) {
      Swal.fire({
        title: i18n.t("tasks.overview.delete-task-modal.title"),
        text: i18n.t(
          "tasks.overview.delete-task-modal.text",
          {taskTitle: task.title}
          ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#556ee6",
        cancelButtonColor: "rgba(221, 51, 51, 0.7)",
        confirmButtonText: `<i class='fa fa-trash' aria-hidden='true'></i> ${i18n.t("yes")}`,
        cancelButtonText: `${i18n.t("no")}`

      }).then((result) => {
        if (result.value) {
          taskService.cancelTask(task)
          .then(response => {
            this.fetchOpenTasks();
            this.$emit("showResponseMessage", response);
          });
        }
      });
    },
  },
  created() {
    this.fetchOpenTasks();
  },
}
</script>

<style lang="scss" scoped>
  .task--function {
    cursor: pointer;

    &__delete-task {
      & i:hover {
      color: red;
      }
    }
  }
</style>